import { Box, Button, Flex, FormControl, FormErrorMessage, FormLabel, Heading, Input, Text } from "@chakra-ui/react";
import { Step, Steps, useSteps } from "chakra-ui-steps";
import { Field, Formik } from "formik";
import { FC, ReactElement, useEffect, useState } from "react";
import { FaArrowCircleRight, FaShoppingCart } from "react-icons/fa";

interface CheckoutCustomerStepProps {
    handleSubmition: any;
    defaultFormValue: any;
};

const CheckoutCustomerStep: FC<CheckoutCustomerStepProps> = ({ handleSubmition, defaultFormValue }): ReactElement => {
    const [formValue, setFormValue] = useState<any>(defaultFormValue);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

    const handleFormSubmit = (values: any) => {
        setIsSubmitting(true);
        handleSubmition(values).then(() => {
            setIsSubmitting(false);
        });
    };

    return (
        <Formik initialValues={formValue} onSubmit={handleFormSubmit}>
            {
                ({ handleSubmit, errors, touched }: any) => (
                    <form onSubmit={handleSubmit} noValidate={true}>
                        <Box mt={{ base: 2, md: 6 }} mb={{ base: 2, md: 6 }} p={{ base: 2, md: 6 }} borderRadius={8} borderStyle={"solid"} borderWidth={{ base: 0, md: 1 }} borderColor={"blackAlpha.300"} textAlign={"center"}>
                            <Heading fontSize="lg">Informasi Anda</Heading>
                            <Text fontSize={"xs"}>Lengkapi informasi Anda dibawah ini. Pastikan email dan nomor whatsapp yang kamu masukkan adalah benar. Sebab kami akan gunakan data tersebut untuk aktivasi dan melakukan konfirmasi terkait pembayaran.</Text>
                            <Box pt={8} pb={0}>
                                <FormControl isRequired isInvalid={!!(errors.name && touched.name)} isDisabled={isSubmitting}>
                                    <FormLabel htmlFor='name' fontSize={"sm"}>Nama Anda</FormLabel>
                                    <Field as={Input} id='name' name={'name'} placeholder='Masukan Nama Anda'
                                        validate={(value: any) => {
                                            let error;
                                            if (value && value.length <= 0) {
                                                error = "Silahkan isi Nama Anda."
                                            }
                                            return error;
                                        }}
                                    />
                                    <FormErrorMessage>{errors.name}</FormErrorMessage>
                                </FormControl>
                            </Box>
                            <Box py={4} pb={0}>
                                <FormControl isRequired isInvalid={!!(errors.email && touched.email)} isDisabled={isSubmitting}>
                                    <FormLabel htmlFor='email' fontSize={"sm"}>Email Terbaik Anda</FormLabel>
                                    <Field as={Input} id='email' name={'email'} placeholder='Masukan Email Anda'
                                        validate={(value: any) => {
                                            let error;
                                            if (value && value.length <= 0) {
                                                error = "Silahkan isi Email Terbaik Anda."
                                            } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i.test(value)) {
                                                error = "Email Anda tidak valid."
                                            }
                                            return error;
                                        }}
                                    />
                                    <FormErrorMessage>{errors.email}</FormErrorMessage>
                                </FormControl>
                            </Box>
                            <Box pt={4}>
                                <FormControl isRequired isInvalid={!!(errors.phone && touched.phone)} isDisabled={isSubmitting}>
                                    <FormLabel htmlFor='phone' fontSize={"sm"}>Nomor Whatsapp Anda</FormLabel>
                                    <Field as={Input} id='phone' name={'phone'} placeholder='No. Whatsapp 08xxxx'
                                        validate={(value: any) => {
                                            let error;
                                            if (value && value.length <= 0) {
                                                error = "Silahkan isi Nomor Whatsapp Anda."
                                            } else if (!/^\d+$/i.test(value)) {
                                                error = "Nomor Whatsapp Anda tidak valid."
                                            }
                                            return error;
                                        }}
                                    />
                                    <FormErrorMessage>{errors.phone}</FormErrorMessage>
                                </FormControl>
                            </Box>
                        </Box>
                        <Flex width="100%" justify="center" mb={6}>
                            <Button type="submit" size={"lg"} rightIcon={<FaArrowCircleRight />} isLoading={isSubmitting}>
                                Selanjutnya
                            </Button>
                        </Flex>
                    </form>
                )}
        </Formik>
    );
};

export default CheckoutCustomerStep;